import { useNavigate } from 'react-router-dom';
import { Database, Upload, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { useOrganizationContext } from '../../organization.context';

export default function UploadKnowledgeManagement() {
  const navigate = useNavigate();
  const { organization } = useOrganizationContext();

  const handleNavigateToKnowledgeManagement = () => {
    navigate(`/dashboard/organizations/${organization.id}/knowledge-management`);
  };

  return (
    <Card
      className="cursor-pointer hover:shadow-md transition-shadow"
      onClick={handleNavigateToKnowledgeManagement}>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Database className="h-5 w-5" />
          Knowledge Management
          <Badge variant="secondary" className="ml-auto">
            New
          </Badge>
        </CardTitle>
        <CardDescription>Bulk upload and manage documents for this organization</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Upload className="h-4 w-4" />
            <span>Upload ZIP files with multiple documents</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Database className="h-4 w-4" />
            <span>AI-powered metadata extraction and organization</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <ArrowRight className="h-4 w-4" />
            <span>Automatic knowledge item creation</span>
          </div>
        </div>

        <Button className="w-full mt-4" onClick={handleNavigateToKnowledgeManagement}>
          Manage Knowledge Content
          <ArrowRight className="h-4 w-4 ml-2" />
        </Button>
      </CardContent>
    </Card>
  );
}
